import { c as _c } from "react/compiler-runtime";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { Tooltip } from "react-tooltip";
interface DropVoteProgressingProps {
  readonly current: number | null | undefined;
  readonly projected: number | null | undefined;
  readonly subtle?: boolean;
}
export default function DropVoteProgressing(t0) {
  const $ = _c(21);
  const {
    current,
    projected,
    subtle: t1
  } = t0;
  const subtle = t1 === undefined ? false : t1;
  if (typeof current !== "number" || typeof projected !== "number") {
    return null;
  }
  const isProgressing = current !== projected;
  if (!isProgressing) {
    return null;
  }
  const isPositiveProgressing = current < projected;
  let color;
  if (subtle) {
    color = isPositiveProgressing ? "tw-text-iron-300 tw-bg-iron-700 tw-transition-colors tw-duration-200" : "tw-text-iron-400 tw-bg-iron-700 tw-transition-colors tw-duration-200";
  } else {
    color = isPositiveProgressing ? "tw-text-emerald-400 tw-bg-emerald-900/40" : "tw-text-rose-400 tw-bg-rose-900/40";
  }
  const t2 = `${color} tw-text-sm tw-font-medium tw-ml-0.5 tw-px-1.5 tw-py-0.5 tw-rounded-md tw-flex tw-items-center tw-gap-x-1`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      animationDuration: "2s"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const t4 = `drop-vote-progress-${current}-${projected}`;
  let t5;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <FontAwesomeIcon icon={faArrowRight} className="tw-flex-shrink-0 tw-size-3" />;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  let t6;
  if ($[2] !== projected) {
    t6 = formatNumberWithCommas(projected);
    $[2] = projected;
    $[3] = t6;
  } else {
    t6 = $[3];
  }
  let t7;
  if ($[4] !== t6) {
    t7 = <span>{t6}</span>;
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== t2 || $[7] !== t4 || $[8] !== t7) {
    t8 = <span className={t2} style={t3} data-tooltip-id={t4}>{t5}{t7}</span>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const t9 = `drop-vote-progress-${current}-${projected}`;
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      backgroundColor: "#1F2937",
      color: "white",
      padding: "4px 8px",
      zIndex: 50,
      boxShadow: "0 4px 16px 0 rgba(0,0,0,0.30), 0 2px 8px 0 rgba(55,55,62,0.25)"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== projected) {
    t11 = formatNumberWithCommas(projected);
    $[11] = projected;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t11) {
    t12 = <span className="tw-text-xs">Projected vote count at decision time:{" "}{t11}</span>;
    $[13] = t11;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t12 || $[16] !== t9) {
    t13 = <Tooltip id={t9} place="top" positionStrategy="absolute" opacity={1} style={t10}>{t12}</Tooltip>;
    $[15] = t12;
    $[16] = t9;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13 || $[19] !== t8) {
    t14 = <>{t8}{t13}</>;
    $[18] = t13;
    $[19] = t8;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  return t14;
}